<template>
  <div class="main">
    <!-- channel banner -->
    <div class="cbanner">
      <img src="../../assets/images/banner_ucenter.jpg" />
      <div class="btext">
        <h3>我的借贷</h3>
        <p>最低投资成本，最好的安全保证，专业互联网借贷信息中介平台</p>
      </div>
    </div><!-- channel banner END-->
    <div class="main_inner">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <span class="btitle">当前位置：</span>
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户中心</el-breadcrumb-item>
        <el-breadcrumb-item>我的借贷</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row>
        <el-col :span="5" class="leftside">
          <el-menu
            default-active="3"
            class="el-menu-vertical-demo"
          >
            <router-link :to="{ path: '/personalInformation' }">
              <el-menu-item index="1"><span slot="title" >个人信息</span></el-menu-item>
            </router-link>
            <router-link :to="{ path: '/passwordEdit' }">
              <el-menu-item index="2"><span slot="title">修改密码</span></el-menu-item>
            </router-link>
            <router-link :to="{ path: '/myBorrow' }">
              <el-menu-item index="3"><span slot="title">我的借贷</span></el-menu-item>
            </router-link>
          </el-menu>
        </el-col>
        <el-col :span="19">
          <div class="con_right mylist_con">

            <!-- my list -->
            <div class="con mylist">
              <h3>我的出借意向
                <div class="static">共 <span class="color_red">{{total}}</span>条&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;<router-link :to="{ path: '/myBorrow' }">返回</router-link></div>
              </h3>
              <template>
                <el-table
                  :data="myLanIntention"
                  style="width: 100%">
                  <el-table-column
                    prop="type"
                    label="意向类型" :formatter="formatType">
                  </el-table-column>
                  <el-table-column
                    prop="contractAmount"
                    label="意向金额(元)">
                  </el-table-column>
                  <el-table-column
                    prop="createTime"
                    label="意向发送时间" :formatter="formatCreateTime">
                  </el-table-column>

                  <el-table-column
                    prop="projectName"
                    label="项目名称"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="disposeStatus"
                    label="当前状态" :formatter="formatDisposeStatus" >
                  </el-table-column>
                  <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                      <el-button type="default" :disabled="(scope.row.projectName=='')" @click="selectLanProject(scope.$index,scope.row)" size="small">查看项目</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </div>

          </div>

          <el-pagination
            background
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  import util from '../../common/util'
  import  {reqMyLanIntentionPage} from "../../api/webUser-api"
  import {reqGetOneLoanProject,reqGetOneBorrowProject} from '../../api/projectManagement-api'
  export default {
    data(){
      return {
        total:0,
        pageNum:1,
        pageSize:15,
        listLoading:false,
        myLanIntention:[],
        form:{
          deadline:'',
          projectId:'',
          projectName:'',
          contractAmount:'',
          disposeStatus:'',
          transDate:'',
          type:'',
          createTime:'',
        },

      }
    },
    methods:{
      handleCurrentChange(val) {
        this.pageNum = val;
        this.currentPage = val;
        this.getLanIntentionPage();
      },
      getLanIntentionPage(){
        var id = window.sessionStorage.getItem('Authorization');
        let param={
          userId:id,
          pageNum:this.pageNum,
          pageSize:this.pageSize,
        };
        reqMyLanIntentionPage(param).then(res=>{
          this.total=res.data.data.total;
          this.myLanIntention=res.data.data.list;

        })
      },

      selectLanProject(index,row){
        this.$router.push({name: 'borrowProjectDetail', query: {id: row.projectId}});
      },
      formatCreateTime:function (row,colnm) {
        if(row.createTime){
          return util.formatDate.format(new Date(row.createTime),'yyyy-MM-dd');
        }
      },
      formatDisposeStatus: function (row, colnm) {
        if (row.disposeStatus == 0) {
          return '已成交'
        } else if (row.disposeStatus == 1) {
          return '未成交'
        } else {
          return '对接中'
        }
      },
      formatType: function (row, colnm) {
        if (row.projectName == ''||row.projectName==null) {
          return '直接意向';
        }
        else  {
          return '项目意向'
        }
      },
    },
    mounted(){
      this.getLanIntentionPage();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/userCenter/MyLoanIntentionPage.vue